import { createIconComponent } from '../../factory/create-icon-component';
export const ThumbsDownIcon = createIconComponent(
  'ThumbsDownIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 3L22 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3564 22C10.7685 22 11.1637 21.8363 11.4551 21.5449L16.1882 16.8118C17.2259 15.7741 17.7448 15.2552 18.1158 14.6497C18.4448 14.1129 18.6872 13.5276 18.8342 12.9154C19 12.2249 19 11.4911 19 10.0236V6.8C19 5.11984 19 4.27976 18.673 3.63803C18.3854 3.07354 17.9265 2.6146 17.362 2.32698C16.7202 2 15.8802 2 14.2 2H7.11801C5.65653 2 4.92579 2 4.33558 2.26743C3.8154 2.50314 3.3733 2.88242 3.06124 3.36072C2.70717 3.90339 2.59606 4.62564 2.37383 6.07012L1.85075 9.47012C1.55764 11.3753 1.41109 12.3279 1.6938 13.0691C1.94194 13.7197 2.40865 14.2637 3.01392 14.6079C3.70353 15 4.66733 15 6.59493 15H8.46141C8.6946 15 8.8112 15 8.89664 15.0098C9.82391 15.1165 10.4296 16.0351 10.1624 16.9294C10.1378 17.0118 10.0919 17.119 10 17.3333L8.92823 19.8341C8.48881 20.8594 9.2409 22 10.3564 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
